// import { useEffect } from 'react';
// import { useFormik } from 'formik';
// import { Card } from '@components/card/card';
// import { CardBody, Form } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import { useNavigate, useParams } from 'react-router-dom';
// import Select from 'react-select';

// import Breadcrumb from '@components/Shared/Breadcrumb';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';

// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { updateMoveTransactions, getMoveTransactionsById } from '@store/INV/Transactions/InvMove/invMoveSlice';

// import useGetTransactionTypesMoveList from '@hooks/INV/InvMove/useGetTransactionTypesMoveList';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
// import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';

// import MoveLines from './MoveLines';
// import Loading from '@components/Shared/Loader/Loading';

// const Update = () => {
//   const { id } = useParams<{ id: string }>();

//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
//   const { InventoryOptions, loading: loadingInv } = useGetInventoryWithPermission();
//   const { TreeSubInventoryData } = useGetSubinventoryList();
//   const { OptionsTransactionTypes } = useGetTransactionTypesMoveList();

//   // console.log(OptionsTransactionTypes);

//   const { moveById, loading: loadingMoveById } = useAppSelector((s: any) => s.InvMove);

//   // 1) جلب البيانات عند فتح صفحة التعديل
//   useEffect(() => {
//     if (id) dispatch(getMoveTransactionsById(id));
//   }, [dispatch, id]);

//   const formik = useFormik({
//     initialValues: {
//       code: moveById ? moveById.code?.slice(0, 3) : 'MOV',
//       branchId: moveById ? moveById.branchId : '',
//       branchTo: moveById ? moveById.branchTo : '',

//       inventoryId: moveById ? moveById.inventoryId : '',
//       inventoryTo: moveById ? moveById.inventoryTo : '',

//       subInventoryId: moveById ? moveById.subInventoryId : null,
//       subInventoryTo: moveById ? moveById.subInventoryTo : null,

//       transactionDate: moveById ? moveById.transactionDate?.split('T')[0] : '',
//       description: moveById ? moveById.description : '',
//       transactionAmount: moveById ? moveById.transactionAmount : 0,
//       referenceType: moveById ? moveById.referenceType : '',
//       referenceId: moveById ? moveById.referenceId : '',

//       supplierId: moveById ? moveById.supplierId : null,
//       customerId: moveById ? moveById.customerId : null,
//       personId: moveById ? moveById.personId : null,

//       address: moveById ? moveById.address : '',
//       note: moveById ? moveById.note : '',

//       referenceCode: moveById ? moveById.referenceCode : '',

//       materialTransactionsLineList: moveById
//         ? moveById.materialTransactionsLineList?.map((ln: any) => ({
//             // خلك مرن لأن أسماء الحقول قد تختلف
//             id: ln.id ?? undefined,
//             transactionItemId: ln.transactionItemId,
//             transactionUom: ln.transactionUom,
//             unitPrice: ln.unitPrice ?? 0,
//             transactionQuantityIn: ln.transactionQuantityIn ?? 0,
//             transactionQuantityOut: ln.transactionQuantityOut ?? 0

//             // inventoryId: ln.inventoryId ?? null,
//             // inventoryTo: ln.inventoryTo ?? null,

//             // discount: ln.discount ?? 0,
//             // currencyCode: ln.currencyCode ?? '',
//             // currencyConversionRate: ln.currencyConversionRate ?? 0,

//             // referenceIdMaster: ln.referenceIdMaster ?? null,
//             // referenceIdLine: ln.referenceIdLine ?? null,

//             // transactionTypeId: ln.transactionTypeId ?? null,
//             // batchId: ln.batchId ?? null
//           }))
//         : []
//     },
//     enableReinitialize: true,
//     onSubmit: values => {
//       if (!id) {
//         CustomAlert({ action: 'Error', msg: 'Missing id' });
//         return;
//       }

//       dispatch(
//         updateMoveTransactions({
//           id, // مهم: إذا السلايس عندك يتوقعه باسم آخر عدله (مثلاً moveTransactionId)
//           code: values.code,
//           branchId: values.branchId,
//           branchTo: values.branchTo || null,

//           inventoryId: values.inventoryId,
//           inventoryTo: values.inventoryTo || null,

//           subInventoryId: values.subInventoryId || null,
//           subInventoryTo: values.subInventoryTo || null,

//           transactionDate: values.transactionDate,
//           description: values.description,
//           transactionAmount: 0,

//           referenceType: values.referenceType,
//           referenceId: values.referenceId || null,

//           supplierId: values.supplierId || null,
//           customerId: values.customerId || null,
//           personId: values.personId || null,

//           address: values.address,
//           note: values.note,
//           referenceCode: values.referenceCode || '',

//           materialTransactionsLineList: (values.materialTransactionsLineList || []).map((item: any) => ({
//             id: item.id ?? undefined, // لو API يحتاج line id للتعديل
//             transactionItemId: item.transactionItemId,
//             transactionUom: item.transactionUom,
//             unitPrice: item.unitPrice,
//             transactionQuantityIn: item.transactionQuantityIn,
//             transactionQuantityOut: 0,

//             inventoryId: null,
//             discount: 0,
//             currencyCode: '',
//             currencyConversionRate: 0,
//             referenceIdMaster: null,
//             referenceIdLine: null,
//             transactionTypeId: null,
//             batchId: null,
//             inventoryTo: null
//           }))
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Edit' });
//             navigate(-1);
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch(() => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     }
//   });

//   const { values, touched, errors, handleChange: formikhandleChange } = formik;

//   // console.log(formik.values.materialTransactionsLineList);

//   return (
//     <>
//       <Breadcrumb
//         BreadcrumbList={[
//           { name: 'Home', link: ':moduleHome' },
//           { name: 'أوامر التحويــل', link: '' },
//           { name: 'تعديل أمر تحويل', link: null }
//         ]}
//         PageName='تعديل أمر تحويــل'
//       />

//       <Loading loading={loadingMoveById}>
//         <Form onSubmit={formik.handleSubmit}>
//           <Card className='shadow'>
//             <CardBody>
//               <div className='row'>
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('تاريخ التحويل')}</label>
//                     <Form.Control
//                       className='form-control text-center'
//                       type='date'
//                       name='transactionDate'
//                       onChange={formikhandleChange}
//                       value={values.transactionDate || ''}
//                     />
//                     <div className='text-danger'>{formik.errors.transactionDate as any}</div>
//                   </div>
//                 </div>

//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('نوع الحركة')}</label>
//                     <Select
//                       isDisabled
//                       classNamePrefix='react-select'
//                       isSearchable
//                       isClearable
//                       options={OptionsTransactionTypes}
//                       value={OptionsTransactionTypes?.find((f: any) => f.value === values.code)}
//                       onChange={(option: any) => formik.setFieldValue('code', option === null ? null : option.value)}
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                     />
//                     <div className='text-danger'>{formik.errors.code as any}</div>
//                   </div>
//                 </div>

//                 {values.code === 'MOV' && (
//                   <>
//                     <div className='col-lg-3'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('الفرع المحول منه')}</label>
//                         <Select
//                           isDisabled
//                           classNamePrefix='react-select'
//                           isLoading={loadingInv}
//                           isSearchable
//                           isClearable
//                           options={OperatingUnitOptions}
//                           value={OperatingUnitOptions?.find((f: any) => f.value === values.branchId)}
//                           onChange={option => {
//                             formik.setFieldValue('inventoryId', '');
//                             formik.setFieldValue('subInventoryId', null);
//                             formik.setFieldValue('branchId', option?.value || '');
//                           }}
//                           placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                         />
//                         <div className='text-danger'>{formik.errors.branchId as any}</div>
//                       </div>
//                     </div>

//                     <div className='col-lg-3'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('المخزن المحول منه')}</label>
//                         <Select
//                           isDisabled
//                           classNamePrefix='react-select'
//                           isLoading={loadingInv}
//                           isSearchable
//                           isClearable
//                           options={InventoryOptions?.filter((f: any) => f.operatingUnitId === values.branchId)}
//                           value={
//                             values.inventoryId && InventoryOptions?.find((f: any) => f.value === values.inventoryId)
//                           }
//                           onChange={(option: any) => {
//                             formik.setFieldValue('inventoryId', option === null ? null : option.value);
//                             formik.setFieldValue('subInventoryId', null);
//                           }}
//                           placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                         />
//                         <div className='text-danger'>{formik.errors.inventoryId as any}</div>
//                       </div>
//                     </div>

//                     <div className='col-lg-3'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('الفرع المحول اليه')}</label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isLoading={loadingInv}
//                           isSearchable
//                           isClearable
//                           options={OperatingUnitOptions}
//                           value={OperatingUnitOptions?.find((f: any) => f.value === values.branchTo)}
//                           onChange={option => {
//                             formik.setFieldValue('inventoryTo', '');
//                             formik.setFieldValue('subInventoryTo', null);
//                             formik.setFieldValue('branchTo', option?.value || '');
//                           }}
//                           placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                         />
//                         <div className='text-danger'>{formik.errors.branchTo as any}</div>
//                       </div>
//                     </div>

//                     <div className='col-lg-3'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('المخزن المحول اليه')}</label>
//                         <Select
//                           classNamePrefix='react-select'
//                           isLoading={loadingInv}
//                           isSearchable
//                           isClearable
//                           options={InventoryOptions?.filter((f: any) => f.operatingUnitId === values.branchTo)}
//                           value={
//                             values.inventoryTo && InventoryOptions?.find((f: any) => f.value === values.inventoryTo)
//                           }
//                           onChange={(option: any) => {
//                             formik.setFieldValue('inventoryTo', option === null ? null : option.value);
//                             formik.setFieldValue('subInventoryTo', null);
//                           }}
//                           placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                         />
//                         <div className='text-danger'>{formik.errors.inventoryTo as any}</div>
//                       </div>
//                     </div>
//                   </>
//                 )}

//                 <div className='col-xl-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('طريقة التحويل')}</label>
//                     <Form.Select
//                       className='form-select'
//                       name='referenceType'
//                       onChange={formik.handleChange}
//                       value={values.referenceType}
//                     >
//                       <option key={''}>{i18n.language === 'ar' ? 'اختر' : 'Choose'}</option>
//                       <option key={'direct'}>{i18n.language === 'ar' ? 'مباشر' : 'Direct'}</option>
//                       <option key={'Indirect'}>{i18n.language === 'ar' ? 'غير مباشر' : 'Indirect'}</option>
//                     </Form.Select>
//                   </div>
//                 </div>

//                 <div className='col-lg-12'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Note')}</label>
//                     <Form.Control
//                       autoComplete='off'
//                       className='form-control'
//                       as='textarea'
//                       rows={1}
//                       name='description'
//                       onChange={formik.handleChange}
//                       value={values.description}
//                       isInvalid={!!(touched.description && errors.description)}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>

//           <Card className='shadow mt-3'>
//             <MoveLines formik={formik} isUpdate />
//           </Card>
//           <Card className='shadow mt-3 p-1'>
//             <div className='text-end  '>
//               <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme rounded-1'>
//                 {formik.isSubmitting ? (
//                   <div className='spinner-border spinner-border-sm me-2'></div>
//                 ) : (
//                   <i className='fas fa-lg fa-fw me-2 fa-save'></i>
//                 )}
//                 {t('حفظ التعديل')}
//               </button>

//               <button type='button' className='btn btn-lg me-1 btn-default rounded-1 ' onClick={() => navigate(-1)}>
//                 <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//               </button>
//             </div>
//           </Card>
//         </Form>
//       </Loading>
//     </>
//   );
// };

// export default Update;

import { useEffect } from 'react';
import { useFormik } from 'formik';
import { Card } from '@components/card/card';
import { CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';

import Breadcrumb from '@components/Shared/Breadcrumb';
import CustomAlert from '@components/Shared/Alert/CustomAlert';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { updateMoveTransactions, getMoveTransactionsById } from '@store/INV/Transactions/InvMove/invMoveSlice';

import useGetTransactionTypesMoveList from '@hooks/INV/InvMove/useGetTransactionTypesMoveList';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';

import MoveLines from './MoveLines';
import Loading from '@components/Shared/Loader/Loading';

// ✅ NEW: نفس lookup المستخدم للتحقق قبل الحفظ
import { fetchItemsWithUomLookup } from '@pages/INV/lookups/itemsWithUomLookup.api';

// -----------------------------
// Helpers
// -----------------------------
const chunk = <T,>(arr: T[], size: number) => {
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

// ✅ يتحقق أن كل itemId موجود في inventoryTo (اختياري: subInventoryTo)
const validateItemsExistInInventoryTo = async (vals: any) => {
  const destInventoryId = vals?.inventoryTo;
  if (!destInventoryId) return { ok: true, missing: [] as string[] };

  const lines = Array.isArray(vals?.materialTransactionsLineList) ? vals.materialTransactionsLineList : [];
  const itemIds = Array.from(
    new Set(lines.filter((l: any) => l?.transactionItemId).map((l: any) => String(l.transactionItemId)))
  );

  if (itemIds.length === 0) return { ok: true, missing: [] as string[] };

  const params: any = { InventoryId: destInventoryId, Scope: 1 };
  if (vals?.subInventoryTo) params.SubInventoryId = vals.subInventoryTo;

  const found = new Set<string>();
  const controller = new AbortController();

  for (const idsChunk of chunk(itemIds, 200)) {
    const resp = await fetchItemsWithUomLookup(
      params,
      {
        pageIndex: 1,
        pageSize: 3000,
        itemType: 'InventoryItem',
        itemIds: idsChunk
      } as any,
      controller.signal
    );

    const list = resp?.data?.data || [];
    for (const r of list) {
      const id = String((r as any)?.itemId ?? '');
      if (id) found.add(id);
    }
  }

  const missing = itemIds.filter((id: any) => !found.has(id));
  return { ok: missing.length === 0, missing };
};

const Update = () => {
  const { id } = useParams<{ id: string }>();

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loadingInv } = useGetInventoryWithPermission();
  const { TreeSubInventoryData } = useGetSubinventoryList();
  const { OptionsTransactionTypes } = useGetTransactionTypesMoveList();

  const { moveById, loading: loadingMoveById } = useAppSelector((s: any) => s.InvMove);

  // 1) جلب البيانات عند فتح صفحة التعديل
  useEffect(() => {
    if (id) dispatch(getMoveTransactionsById(id));
  }, [dispatch, id]);

  const formik = useFormik({
    initialValues: {
      code: moveById ? moveById.code?.slice(0, 3) : 'MOV',

      branchId: moveById ? moveById.branchId : '',
      branchTo: moveById ? moveById.branchTo : '',

      inventoryId: moveById ? moveById.inventoryId : '',
      inventoryTo: moveById ? moveById.inventoryTo : '',

      subInventoryId: moveById ? moveById.subInventoryId : null,
      subInventoryTo: moveById ? moveById.subInventoryTo : null,

      transactionDate: moveById ? moveById.transactionDate?.split('T')[0] : '',
      description: moveById ? moveById.description : '',
      transactionAmount: moveById ? moveById.transactionAmount : 0,

      referenceType: moveById ? moveById.referenceType : '',
      referenceId: moveById ? moveById.referenceId : '',

      supplierId: moveById ? moveById.supplierId : null,
      customerId: moveById ? moveById.customerId : null,
      personId: moveById ? moveById.personId : null,

      address: moveById ? moveById.address : '',
      note: moveById ? moveById.note : '',

      referenceCode: moveById ? moveById.referenceCode : '',

      // ✅ NEW: طريقة التسعير
      methodTransfer: moveById?.methodTransfer ?? 1,

      materialTransactionsLineList: moveById
        ? moveById.materialTransactionsLineList?.map((ln: any) => ({
            id: ln.id ?? undefined,
            transactionItemId: ln.transactionItemId,
            transactionUom: ln.transactionUom,
            unitPrice: ln.unitPrice ?? 0,
            transactionQuantityIn: ln.transactionQuantityIn ?? 0,
            transactionQuantityOut: ln.transactionQuantityOut ?? 0,
            lotId: ln.lotId ?? null
          }))
        : []
    },
    enableReinitialize: true,

    // ✅ async حتى نعمل التشييك قبل الحفظ (لو inventoryTo قابل للتغيير)
    onSubmit: async values => {
      try {
        if (!id) {
          CustomAlert({ action: 'Error', msg: 'Missing id' });
          return;
        }

        // ✅ 1) تحقق قبل الحفظ: كل الأصناف موجودة في inventoryTo
        const check = await validateItemsExistInInventoryTo(values);
        if (!check.ok) {
          formik.setSubmitting(false);
          CustomAlert({
            action: 'Error',
            msg:
              t('لا يمكن حفظ التحويل لأن بعض الأصناف غير موجودة في المخزن المحول إليه') + ` (${check.missing.length})`
          });
          return;
        }

        // ✅ 2) إذا OK كمل الحفظ
        dispatch(
          updateMoveTransactions({
            id,
            code: values.code,

            branchId: values.branchId,
            branchTo: values.branchTo || null,

            inventoryId: values.inventoryId,
            inventoryTo: values.inventoryTo || null,

            subInventoryId: values.subInventoryId || null,
            subInventoryTo: values.subInventoryTo || null,

            transactionDate: values.transactionDate,
            description: values.description,
            transactionAmount: 0,

            referenceType: values.referenceType,
            referenceId: values.referenceId || null,

            supplierId: values.supplierId || null,
            customerId: values.customerId || null,
            personId: values.personId || null,

            address: values.address,
            note: values.note,
            referenceCode: values.referenceCode || '',

            // ✅ NEW
            methodTransfer: values.methodTransfer,

            materialTransactionsLineList: (values.materialTransactionsLineList || []).map((item: any) => ({
              id: item.id ?? undefined,
              transactionItemId: item.transactionItemId,
              transactionUom: item.transactionUom,

              // ✅ نفس قاعدة الإضافة:
              // methodTransfer=1 => unitPrice = 0
              // methodTransfer=2 => unitPrice = user input
              unitPrice: Number(values.methodTransfer) === 2 ? Number(item.unitPrice || 0) : 0,

              transactionQuantityIn: item.transactionQuantityIn,
              transactionQuantityOut: 0,

              lotId: item.lotId ?? null,

              inventoryId: null,
              discount: 0,
              currencyCode: '',
              currencyConversionRate: 0,
              referenceIdMaster: null,
              referenceIdLine: null,
              transactionTypeId: null,
              batchId: null,
              inventoryTo: null
            }))
          })
        )
          .unwrap()
          .then((res: any) => {
            if (res?.succeeded === true) {
              CustomAlert({ action: 'Edit' });
              navigate(-1);
            } else {
              formik.setSubmitting(false);
              CustomAlert({ action: 'Error', msg: res?.message });
            }
          })
          .catch(() => {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error' });
          });
      } catch (e) {
        formik.setSubmitting(false);
        CustomAlert({ action: 'Error', msg: t('تعذر التحقق من الأصناف في المخزن المحول إليه') });
      }
    }
  });

  const { values, touched, errors, handleChange: formikhandleChange } = formik;

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          { name: 'Home', link: ':moduleHome' },
          { name: 'أوامر التحويــل', link: '' },
          { name: 'تعديل أمر تحويل', link: null }
        ]}
        PageName='تعديل أمر تحويــل'
      />

      <Loading loading={loadingMoveById}>
        <Form onSubmit={formik.handleSubmit}>
          <Card className='shadow'>
            <CardBody>
              <div className='row'>
                <div className='col-lg-3'>
                  <div className='form-group flex-nowrap mb-3'>
                    <label className='form-label'>{t('رقم أمر التحويل')}</label>

                    <div className='input-group flex-nowrap'>
                      <Form.Control
                        readOnly
                        className='form-control fw-bold text-center fs-5 text-theme'
                        type='text'
                        autoComplete='off'
                        onChange={formikhandleChange}
                        value={moveById.code || ''}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('نوع الحركة')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isSearchable
                      isClearable
                      options={OptionsTransactionTypes}
                      value={OptionsTransactionTypes?.find((f: any) => f.value === values.code)}
                      onChange={(option: any) => formik.setFieldValue('code', option === null ? null : option.value)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    <div className='text-danger'>{formik.errors.code as any}</div>
                  </div>
                </div>

                <div className='col-lg-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('تاريخ التحويل')}</label>
                    <Form.Control
                      className='form-control text-center'
                      type='date'
                      name='transactionDate'
                      onChange={formikhandleChange}
                      value={values.transactionDate || ''}
                    />
                    <div className='text-danger'>{formik.errors.transactionDate as any}</div>
                  </div>
                </div>

                {/* ✅ NEW: طريقة التسعير (قراءة فقط) */}
                <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('طريقة التسعير')}</label>
                    <Form.Select className='form-select' value={values.methodTransfer ?? 0} disabled>
                      <option value={1}>{i18n.language === 'ar' ? 'بدون سعر' : 'No Price'}</option>
                      <option value={2}>{i18n.language === 'ar' ? 'سعر يدوي' : 'Manual Price'}</option>
                    </Form.Select>
                  </div>
                </div>

                {values.code === 'MOV' && (
                  <>
                    <div className='col-lg-3'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('الفرع المحول منه')}</label>
                        <Select
                          isDisabled
                          classNamePrefix='react-select'
                          isLoading={loadingInv}
                          isSearchable
                          isClearable
                          options={OperatingUnitOptions}
                          value={OperatingUnitOptions?.find((f: any) => f.value === values.branchId)}
                          onChange={option => {
                            formik.setFieldValue('inventoryId', '');
                            formik.setFieldValue('subInventoryId', null);
                            formik.setFieldValue('branchId', option?.value || '');
                          }}
                          placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                        />
                        <div className='text-danger'>{formik.errors.branchId as any}</div>
                      </div>
                    </div>

                    <div className='col-lg-3'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('المخزن المحول منه')}</label>
                        <Select
                          isDisabled
                          classNamePrefix='react-select'
                          isLoading={loadingInv}
                          isSearchable
                          isClearable
                          options={InventoryOptions?.filter((f: any) => f.operatingUnitId === values.branchId)}
                          value={
                            values.inventoryId && InventoryOptions?.find((f: any) => f.value === values.inventoryId)
                          }
                          onChange={(option: any) => {
                            formik.setFieldValue('inventoryId', option === null ? null : option.value);
                            formik.setFieldValue('subInventoryId', null);
                          }}
                          placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                        />
                        <div className='text-danger'>{formik.errors.inventoryId as any}</div>
                      </div>
                    </div>

                    <div className='col-lg-3'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('الفرع المحول اليه')}</label>
                        <Select
                          classNamePrefix='react-select'
                          isLoading={loadingInv}
                          isSearchable
                          isClearable
                          options={OperatingUnitOptions}
                          value={OperatingUnitOptions?.find((f: any) => f.value === values.branchTo)}
                          onChange={option => {
                            formik.setFieldValue('inventoryTo', '');
                            formik.setFieldValue('subInventoryTo', null);
                            formik.setFieldValue('branchTo', option?.value || '');
                          }}
                          placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                          }}
                        />
                        <div className='text-danger'>{formik.errors.branchTo as any}</div>
                      </div>
                    </div>

                    <div className='col-lg-3'>
                      <div className='form-group mb-3'>
                        <label className='form-label'>{t('المخزن المحول اليه')}</label>
                        <Select
                          classNamePrefix='react-select'
                          isLoading={loadingInv}
                          isSearchable
                          isClearable
                          options={InventoryOptions?.filter((f: any) => f.operatingUnitId === values.branchTo)}
                          value={
                            values.inventoryTo && InventoryOptions?.find((f: any) => f.value === values.inventoryTo)
                          }
                          onChange={(option: any) => {
                            formik.setFieldValue('inventoryTo', option === null ? null : option.value);
                            formik.setFieldValue('subInventoryTo', null);
                          }}
                          placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                          }}
                        />
                        <div className='text-danger'>{formik.errors.inventoryTo as any}</div>
                      </div>
                    </div>
                  </>
                )}

                {/* <div className='col-xl-3'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('طريقة التحويل')}</label>
                    <Form.Select
                      className='form-select'
                      name='referenceType'
                      onChange={formik.handleChange}
                      value={values.referenceType}
                    >
                      <option value={''}>{i18n.language === 'ar' ? 'اختر' : 'Choose'}</option>
                      <option value={'direct'}>{i18n.language === 'ar' ? 'مباشر' : 'Direct'}</option>
                      <option value={'Indirect'}>{i18n.language === 'ar' ? 'غير مباشر' : 'Indirect'}</option>
                    </Form.Select>
                  </div>
                </div> */}

                <div className='col-lg-12'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Note')}</label>
                    <Form.Control
                      autoComplete='off'
                      className='form-control'
                      as='textarea'
                      rows={1}
                      name='description'
                      onChange={formik.handleChange}
                      value={values.description}
                      isInvalid={!!(touched.description && errors.description)}
                    />
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>

          <Card className='shadow mt-3'>
            <MoveLines key={id} formik={formik} isUpdate />
          </Card>

          <Card className='shadow mt-3 p-1'>
            <div className='text-end'>
              <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme rounded-1'>
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fas fa-lg fa-fw me-2 fa-save'></i>
                )}
                {t('حفظ التعديل')}
              </button>

              <button type='button' className='btn btn-lg me-1 btn-default rounded-1' onClick={() => navigate(-1)}>
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </Card>
        </Form>
      </Loading>
    </>
  );
};

export default Update;
